export const LOCATIONS = [
  {
    slug: "washington-dc",
    name: "Washington, DC",
    short: "Washington DC",
    airport: "DCA, IAD & BWI",
    agency: "Washington Passport Agency",
    intro:
      "Travel Passport and Visa LLC is headquartered at 1629 K St NW in downtown Washington, DC — minutes from the Washington Passport Agency and the embassies that line Massachusetts Avenue. For DC travelers, that means documentation assistance from a team that works with these processes every day.",
    context:
      "Washington travelers fly internationally from Reagan National, Dulles, and BWI. Appointments at the Washington Passport Agency are scheduled through the U.S. Department of State, and embassy requirements for visas are set by each consulate. We help DC-area travelers prepare materials for both.",
  },
  {
    slug: "arlington-va",
    name: "Arlington, VA",
    short: "Arlington",
    airport: "DCA & IAD",
    agency: "Washington Passport Agency",
    intro:
      "Just across the Potomac from our K Street office, Arlington travelers are among the most internationally mobile in the country — defense, consulting, and global nonprofit professionals who can't afford documentation delays.",
    context:
      "With Reagan National minutes away and Dulles handling long-haul departures, Arlington residents often face tight international timelines. Appointments at the Washington Passport Agency are managed by the U.S. Department of State; we help you arrive prepared.",
  },
  {
    slug: "alexandria-va",
    name: "Alexandria, VA",
    short: "Alexandria",
    airport: "DCA & IAD",
    agency: "Washington Passport Agency",
    intro:
      "From Old Town to the West End, Alexandria families and professionals rely on organized, accurate travel-document preparation. Our DC office is a short trip up the parkway.",
    context:
      "Alexandria travelers typically depart from Reagan National or Dulles. Whether it's a family vacation requiring child passports or a business trip needing visa support, we help Alexandria clients prepare complete applications before submission.",
  },
  {
    slug: "northern-virginia",
    name: "Northern Virginia",
    short: "Northern Virginia",
    airport: "IAD & DCA",
    agency: "Washington Passport Agency",
    intro:
      "Northern Virginia's technology corridors, government contractors, and international communities generate constant demand for passport and visa assistance. We serve travelers throughout Fairfax, Loudoun, and Prince William counties.",
    context:
      "With Dulles International as the region's long-haul gateway, Northern Virginia travelers frequently need business visas, family passports, and document authentication. Our Washington, DC office supports the entire region with professional preparation services.",
  },
  {
    slug: "maryland",
    name: "Maryland",
    short: "Maryland",
    airport: "BWI, DCA & IAD",
    agency: "Washington Passport Agency",
    intro:
      "From Bethesda and Rockville to Baltimore and Annapolis, Maryland travelers use our Washington, DC office for passport, visa, and document services. The state's biotech, healthcare, and federal workforce travels internationally year-round.",
    context:
      "Maryland travelers depart from BWI, Reagan National, and Dulles. The Washington Passport Agency serves the region by appointment through the U.S. Department of State, and we help Maryland clients prepare materials correctly before any appointment or submission.",
  },
  {
    slug: "virginia",
    name: "Virginia",
    short: "Virginia",
    airport: "IAD, DCA, RIC & ORF",
    agency: "Washington Passport Agency",
    intro:
      "We assist travelers across the Commonwealth — from Richmond and Norfolk to Charlottesville and Roanoke — with passport applications, visa documentation, apostilles, and authentication services.",
    context:
      "Virginia's international travelers depart from Dulles, Reagan National, Richmond, and Norfolk. Wherever you're based in the state, our team provides the same professional document preparation and clear guidance on government requirements and fees.",
  },
  {
    slug: "new-york",
    name: "New York",
    short: "New York",
    airport: "JFK, EWR & LGA",
    agency: "New York Passport Agency",
    intro:
      "New York travelers move through JFK, Newark, and LaGuardia to every corner of the world. We assist New York individuals and businesses with passport services, visa documentation, and travel-document preparation.",
    context:
      "The New York Passport Agency serves the region by appointment through the U.S. Department of State, and New York hosts one of the largest consular corps in the world — each with its own visa requirements. We help you prepare for both.",
  },
  {
    slug: "los-angeles",
    name: "Los Angeles",
    short: "Los Angeles",
    airport: "LAX",
    agency: "Los Angeles Passport Agency",
    intro:
      "Los Angeles is a global city — entertainment, trade, and family ties spanning the Pacific and Latin America. We assist LA travelers with passports, visas, apostilles, and document authentication.",
    context:
      "LAX is one of the world's busiest international gateways. The Los Angeles Passport Agency handles urgent travel by appointment through the U.S. Department of State, and consulates across the city set their own visa rules. We help you navigate both with professionally prepared materials.",
  },
  {
    slug: "chicago",
    name: "Chicago",
    short: "Chicago",
    airport: "ORD & MDW",
    agency: "Chicago Passport Agency",
    intro:
      "Chicago's business community and globally connected families depend on smooth international travel. We provide passport, visa, and document services to travelers throughout the Chicago area.",
    context:
      "O'Hare offers nonstop service to destinations worldwide. The Chicago Passport Agency serves urgent travelers by appointment through the U.S. Department of State, and the city's consulates each maintain distinct visa requirements — we help you prepare for all of them.",
  },
  {
    slug: "atlanta",
    name: "Atlanta",
    short: "Atlanta",
    airport: "ATL",
    agency: "Atlanta Passport Agency",
    intro:
      "Home to the world's busiest airport, Atlanta is a hub for international business and family travel. We assist Atlanta travelers with passport services, visa preparation, and document authentication.",
    context:
      "Hartsfield-Jackson connects Atlanta to the world. The Atlanta Passport Agency handles urgent travel by appointment through the U.S. Department of State. Whether you're flying for business or a family trip, we help ensure your documentation is ready before you are.",
  },
  {
    slug: "miami",
    name: "Miami",
    short: "Miami",
    airport: "MIA & FLL",
    agency: "Miami Passport Agency",
    intro:
      "Miami is the gateway to Latin America and the Caribbean — and one of the cruise capitals of the world. We assist Miami travelers with passports, visas, apostilles, and translations for international use.",
    context:
      "MIA and the Port of Miami generate enormous demand for travel documents. The Miami Passport Agency serves urgent travelers by appointment through the U.S. Department of State, and the city's many consulates maintain varied visa requirements. We help you prepare for both air and sea travel documentation needs.",
  },
  {
    slug: "houston",
    name: "Houston",
    short: "Houston",
    airport: "IAH & HOU",
    agency: "Houston Passport Agency",
    intro:
      "Houston's energy, healthcare, and aerospace industries send professionals worldwide on demanding schedules. We assist Houston travelers and companies with passports, business visas, and document authentication.",
    context:
      "Bush Intercontinental is a major international gateway. The Houston Passport Agency handles urgent travel by appointment through the U.S. Department of State, and Houston's large consular corps serves visa applicants for destinations worldwide — each with requirements we help you meet.",
  },
  {
    slug: "dallas",
    name: "Dallas",
    short: "Dallas",
    airport: "DFW & DAL",
    agency: "Dallas Passport Agency",
    intro:
      "Dallas-Fort Worth is one of America's most connected metros. We assist DFW travelers and businesses with passport services, visa preparation, apostilles, and corporate travel documentation.",
    context:
      "DFW Airport offers nonstop flights across six continents. The Dallas Passport Agency serves urgent travelers by appointment through the U.S. Department of State. We help Dallas-area clients prepare complete, accurate materials for passports and consular visa applications.",
  },
  {
    slug: "boston",
    name: "Boston",
    short: "Boston",
    airport: "BOS",
    agency: "Boston Passport Agency",
    intro:
      "Boston's universities, hospitals, and biotech sector create constant international travel demand. We assist Boston travelers with passports, visas, and document services for study, research, and business abroad.",
    context:
      "Logan International connects New England to Europe and beyond. The Boston Passport Agency handles urgent travel by appointment through the U.S. Department of State. We help students, researchers, and professionals prepare documentation correctly the first time.",
  },
  {
    slug: "philadelphia",
    name: "Philadelphia",
    short: "Philadelphia",
    airport: "PHL",
    agency: "Philadelphia Passport Agency",
    intro:
      "Philadelphia travelers — from Center City professionals to Main Line families — rely on organized travel-document preparation. We provide passport, visa, and document services throughout the region.",
    context:
      "PHL offers transatlantic and international service. The Philadelphia Passport Agency serves urgent travelers by appointment through the U.S. Department of State. Our team helps Philadelphia-area clients prepare applications that meet current government and consular requirements.",
  },
  {
    slug: "san-francisco",
    name: "San Francisco",
    short: "San Francisco",
    airport: "SFO & OAK",
    agency: "San Francisco Passport Agency",
    intro:
      "The Bay Area's technology industry and Pacific Rim connections drive constant international travel. We assist San Francisco travelers with passports, business visas, and document authentication.",
    context:
      "SFO is a primary gateway to Asia. The San Francisco Passport Agency handles urgent travel by appointment through the U.S. Department of State, and the city's consulates serve visa applicants for destinations across Asia, Europe, and beyond. We prepare your materials to their specifications.",
  },
  {
    slug: "seattle",
    name: "Seattle",
    short: "Seattle",
    airport: "SEA",
    agency: "Seattle Passport Agency",
    intro:
      "Seattle's tech workforce and Asia-Pacific business ties make international travel routine. We assist Seattle travelers with passports, visas, and document services for business and leisure.",
    context:
      "Sea-Tac offers extensive nonstop service to Asia and Europe, and Seattle is a major cruise departure port. The Seattle Passport Agency serves urgent travelers by appointment through the U.S. Department of State. We help you prepare for air, sea, and business travel documentation.",
  },
  {
    slug: "denver",
    name: "Denver",
    short: "Denver",
    airport: "DEN",
    agency: "Denver Passport Agency",
    intro:
      "Denver's growing international business community and adventure-travel culture keep passports working hard. We assist Denver travelers with passport services, visas, and document authentication.",
    context:
      "Denver International is one of the country's fastest-growing international gateways. The Denver Passport Agency handles urgent travel by appointment through the U.S. Department of State. We help Colorado travelers prepare complete, accurate applications.",
  },
  {
    slug: "nashville",
    name: "Nashville",
    short: "Nashville",
    airport: "BNA",
    agency: null,
    intro:
      "Nashville's music, entertainment, and healthcare industries tour and operate worldwide. We assist Nashville artists, crews, executives, and families with passports, visas, and document preparation.",
    context:
      "Nashville International continues to add international routes. Tennessee travelers seeking urgent appointments are typically served by regional passport agencies through the U.S. Department of State's appointment system. We help you understand your options and prepare your materials.",
  },
  {
    slug: "charlotte",
    name: "Charlotte",
    short: "Charlotte",
    airport: "CLT",
    agency: null,
    intro:
      "Charlotte's banking and corporate sector travels internationally on tight schedules. We assist Charlotte professionals and families with passport services, business visas, and document authentication.",
    context:
      "Charlotte Douglas is a major connecting hub with growing international service. North Carolina travelers use regional passport agencies through the U.S. Department of State's appointment system for urgent needs. We prepare your documentation so any appointment goes smoothly.",
  },
  {
    slug: "raleigh",
    name: "Raleigh",
    short: "Raleigh",
    airport: "RDU",
    agency: null,
    intro:
      "The Research Triangle's technology, research, and academic communities travel globally year-round. We assist Raleigh-Durham travelers with passports, visas, and document services.",
    context:
      "RDU offers international service to Europe and beyond. North Carolina travelers access regional passport agencies by appointment through the U.S. Department of State. We help researchers, professionals, and families prepare complete applications.",
  },
  {
    slug: "las-vegas",
    name: "Las Vegas",
    short: "Las Vegas",
    airport: "LAS",
    agency: null,
    intro:
      "Las Vegas hosts international conventions, entertainment productions, and a globally connected hospitality industry. We assist Las Vegas travelers with passports, visas, and travel documents.",
    context:
      "Harry Reid International serves international destinations across three continents. Nevada travelers use regional passport agencies through the U.S. Department of State's appointment system for urgent needs. We help convention teams, performers, and vacationers prepare their documentation.",
  },
  {
    slug: "san-diego",
    name: "San Diego",
    short: "San Diego",
    airport: "SAN",
    agency: "San Diego Passport Agency",
    intro:
      "San Diego's cross-border economy, biotech sector, and military community generate constant travel-document demand. We assist San Diego travelers with passports, visas, and document authentication.",
    context:
      "San Diego International offers direct international service, and the region's proximity to Mexico creates unique documentation needs. The San Diego Passport Agency handles urgent travel by appointment through the U.S. Department of State. We help you prepare for any border or international requirement.",
  },
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
